
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'IconArrowLeft',
  computed: {
    ...mapGetters(['global'])
  }
});
